import imageState from './Image'

const FUIcon = (props: any) => {
    const { name, size, style, width, height } = props

    const s = typeof size === 'number' ? size + 'px' : size
    if (name && name.indexOf('.svg') > -1) {
        return <div {...props} className={props.className + ' fu-icon-svg'} >
            {imageState[name].ReactComponent()}
        </div>
    }
    return (
        name ? <img
            {...props}
            src={imageState[name] || name}
            alt=""
            style={{
                width: width || s,
                height: height || s,
                ...style
            }}
        /> : <div {...props}></div>
    )
}

export default FUIcon
